<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { t } = useI18n();
const { content, contentAttributes } = useMessageContext();

const cards = computed(() => {
  return contentAttributes.value.items || [];
});
</script>

<template>
  <BaseBubble class="p-3 overflow-hidden" data-bubble-name="cards">
    <div v-if="content" class="mb-3 text-sm">{{ content }}</div>
    <div class="space-y-3">
      <div
        v-for="(card, index) in cards"
        :key="index"
        class="border border-n-slate-6 rounded-lg p-3 bg-n-slate-2 hover:bg-n-slate-3 transition-colors"
      >
        <h3
          v-if="card.title"
          class="font-semibold text-sm mb-2 text-n-slate-12"
        >
          {{ card.title }}
        </h3>
        <p
          v-if="card.description"
          class="text-sm text-n-slate-11 mb-3 leading-relaxed"
        >
          {{ card.description }}
        </p>
        <div
          v-if="card.actions && card.actions.length"
          class="flex flex-wrap gap-2"
        >
          <template
            v-for="(action, actionIndex) in card.actions"
            :key="actionIndex"
          >
            <a
              v-if="action.type === 'link' && action.uri"
              :href="action.uri"
              target="_blank"
              rel="noopener noreferrer"
              class="inline-flex items-center px-3 py-1.5 text-xs font-medium bg-n-solid-blue text-white rounded-md hover:bg-n-blue-10 transition-colors skip-context-menu"
            >
              {{ action.text || t('CARDS.VIEW_ALL') }}
              <svg
                class="ml-1 w-3 h-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </a>
          </template>
        </div>
      </div>
    </div>
  </BaseBubble>
</template>
